export default [
  { name: 'English (EN-GB)', locale: 'en' },
  { name: 'Français (FR)', locale: 'fr' },
  { name: 'Español (ES-ES)', locale: 'es' }
]
